"use client";

import GetRandomGifUseCaseInstance from "@forcode/domain/src/domain/useCases/GetRandomGifUseCase";
import { GifDto } from "@forcode/domain/src/infrastructure";
import { useCallback, useEffect, useState } from "react";
import { Button, Divider, Image, Typography } from "../../atom";
import css from "./ErrorMessage.module.css";

export const BASE_CLASS = "f-OrganismErrorMessage";

export const ErrorMessage = ({ onClick = () => {} }) => {
  const [randomGif, setRandomGif] = useState<GifDto | null>(null);

  const getRandomGif = useCallback(async () => {
    const gif = await GetRandomGifUseCaseInstance.execute();
    setRandomGif(gif);
  }, []);

  useEffect(() => {
    getRandomGif();
  }, [getRandomGif]);

  if (!randomGif) return null;

  return (
    <section className={css[BASE_CLASS]}>
      <section>
        <header>
          <Divider />
          <Typography as="h2">Oops!</Typography>
          <Typography as="h3">Not expected to see you here 🙈</Typography>
        </header>
        <article>
          <Divider />
          <Typography as="p">
            Please, try again or reported to us in order to fix it ASAP ❤️
          </Typography>
          <Typography as="p">Apologize for the error 🙏🏻</Typography>
          <Button onClick={onClick}>Try again</Button>
        </article>
        <article className={css[`${BASE_CLASS}-image`]}>
          <Image
            alt={randomGif.alt}
            src={randomGif.src}
            width={350}
            height={350}
            position="centered"
          />
        </article>
      </section>
    </section>
  );
};
